var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('LoadWhenVisible',[(_vm.options.length > 0)?_c('product-options',{attrs:{"sku":_vm.product.sku,"options":_vm.options,"optionAttributeUid":_vm.naturaOptionAttributeUid}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }